// Import GSAP, ScrollTrigger, and MotionPathPlugin
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the plugins
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

// Create the animation heart
const lineHeart = document.querySelector('.full-width-image')
if (lineHeart){
  gsap.to('#target', {
    duration: 3,
    motionPath: {
      path: '#mainPath',
      align: '#mainPath',
      alignOrigin: [0.5, 0.5],
      autoRotate: 45,
    },
    scale: 1,
    yoyo: false,
    repeat: false,
    repeatDelay: 0.75,
    ease: 'power3.inOut',
  
    // ScrollTrigger to animate on scroll
    scrollTrigger: {
      trigger: '.full-width-image',
      start: 'top center',
      end: 'bottom center',
      toggleActions: 'play none none reset',
    },
  });
}

// line star animation for half content half image
const hchiSection = document.querySelector('.section-half-image-half-content')
// Create the animation for star
if(hchiSection){
  gsap.to('#targetStar', {
    duration: 6,
    motionPath: {
      path: '#mainLine',
      align: '#mainLine',
      alignOrigin: [0.5, 0.5],
      autoRotate: 45,
    },
    scale: 1,
    yoyo: false,
    repeat: false,
    repeatDelay: 0.75,
    ease: 'power3.inOut',
  
    // ScrollTrigger to animate on scroll
    scrollTrigger: {
      trigger: '.section-half-image-half-content',
      start: 'top center',
      end: 'bottom center',
      toggleActions: 'play none none reset',
    },
  });
}
// line star animation for client stories
// Create the animation for star
const clientStories = document.querySelector('.section-featured-stories');
if(clientStories){
  gsap.to('#clientStar', {
    duration: 6,
    motionPath: {
      path: '#clientLine',
      align: '#clientLine',
      alignOrigin: [0.5, 0.5],
      autoRotate: 45,
    },
    scale: 1,
    yoyo: false,
    repeat: false,
    repeatDelay: 0.75,
    ease: 'power3.inOut',
  
    // ScrollTrigger to animate on scroll
    scrollTrigger: {
      trigger: '.section-featured-stories',
      start: 'top center',
      end: 'bottom center',
      toggleActions: 'play none none reset',
    },
  });

}
const pricingPlan = document.querySelector('.pricing-plan');
if(pricingPlan){
  gsap.to('#pricingStar', {
    duration: 6,
    motionPath: {
      path: '#pricingLine',
      align: '#pricingLine',
      alignOrigin: [0.5, 0.5],
      autoRotate: 45,
    },
    scale: 1,
    yoyo: false,
    repeat: false,
    repeatDelay: 0.75,
    ease: 'power3.inOut',
  
    // ScrollTrigger to animate on scroll
    scrollTrigger: {
      trigger: '.pricing-plan',
      start: 'top center',
      end: 'bottom center',
      toggleActions: 'play none none reset',
    },
  });

}
